import type { MainNavigationBlock } from '@ps/web-martech-cms-types/SiteHeader';
import { Link } from '@ps/web-shared-components';
import type { ClassNameProp } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { matchPath, useLocation } from 'react-router';

import useCustomHeader from '../../../../hooks/useCustomHeader';

import styles from './BrandLinks.scss';
import type { Props as IconProps } from './Icon/Icon';
import Icon from './Icon/Icon';

export enum Vertical {
  Poker = 'poker',
  Casino = 'casino',
  Sports = 'sports'
}

interface OwnProps {
  brandsInMenu?: boolean;
  main: MainNavigationBlock[];
  onClick?: () => void;
  classes?: {
    root?: string;
    navItem?: string;
    active?: string;
  };
}

export type Props = Partial<ClassNameProp> & OwnProps;

const BrandLinks: React.FC<Props> = ({
  brandsInMenu = false,
  className,
  classes,
  main,
  onClick
}) => {
  const { pathname } = useLocation();
  const { prospectHeader } = useCustomHeader();

  const activeItem = [...main]
    .sort((a, b) => (b.url && a.url ? b.url.length - a.url.length : 0))
    .find((item) => !!matchPath(pathname, { path: item.url }));

  return (
    <div className={classNames(styles.brandLinks, className, classes?.root)}>
      {main?.map((item) => {
        const active = item.url === activeItem?.url && !prospectHeader;
        const linkClasses: Record<string, boolean> = {
          [styles.mobileBrandsIcon]: brandsInMenu,
          [styles.active]: active
        };
        if (classes?.active) {
          linkClasses[classes.active] = active;
        }

        return (
          <Link
            key={item.url}
            href={item.url}
            onClick={onClick}
            trackText={item.track_id}
            title={item.title as string}
            className={classNames(styles.brandLink, classes?.navItem, linkClasses)}
          >
            <Icon icon={item.icon as IconProps['icon']} active={active} />
          </Link>
        );
      })}
    </div>
  );
};

export default BrandLinks;
